'use strict';

angular.module('licensure.services', [

])